import styled from 'styled-components';

export const TagListContainer = styled('table')`
  width: 100%;
  border-collapse: collapse;
`;

export const MyCell = styled('td')`
  padding: 5px 5px;
`;
//
// export const HeadCell = styled('td')`
//   position: absolute;
//   right: 0;
//   top: auto;
//   background: white;
// `;
//
// export const TailCell = styled('td')`
//   position: absolute;
//   width: 5em;
//   left: 0;
//   top: auto;
//   background: white;
// `;
